import { useEffect, useState } from 'react'
import { FetchHookReturnType } from './types'

type ExecuteType<T, S> = FetchHookReturnType<T, S>['execute']

export const useDataRefresh = <T, S>(execute: ExecuteType<T, S>) => {
  const [shouldRefresh, setShouldRefresh] = useState(false)

  useEffect(() => {
    if (shouldRefresh) {
      execute()
      setShouldRefresh(false)
    }
  }, [execute, shouldRefresh])

  return setShouldRefresh
}
